var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquareTickGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "check_box_FILL1_wght400_GRAD0_opsz48",
    d: "M129.967,233.3l9.633-9.667-1.433-1.433-8.2,8.233L126,226.467l-1.433,1.433ZM122,240a2.051,2.051,0,0,1-2-2V218a2.051,2.051,0,0,1,2-2h20a2.051,2.051,0,0,1,2,2v20a2.051,2.051,0,0,1-2,2Z",
    transform: "translate(-120 -216)",
    fill: "#b7b5b6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareTickGray);
export default __webpack_public_path__ + "static/media/square_tick_gray.ea222f4e3f8ecf7b6480c5c9e98c68a9.svg";
export { ForwardRef as ReactComponent };